import type {
  ProjectSchema,
  ProjectsItem,
} from '~/@pages_investing/projects/_project_types/project.types'
import { ProjectImageCarousel } from '../project-image-carousel/ProjectImageCarousel'

type Props = {
  project: ProjectSchema | ProjectsItem
}

type Location = {
  latitude: string
  longitude: string
}

export function ProjectPopupBottom({ project }: Props) {
  const location = ((): Location | null => {
    const coords = (
      project.collateralInfo?.propertyInfo?.mapCoordinates ?? ''
    ).split(',')
    if (coords.length !== 2) return null

    const [latitude, longitude] = coords
    return { latitude, longitude }
  })()

  return (
    <div className="flex h-[360px] w-full max-[986px]:h-full max-[986px]:flex-col">
      <ProjectImages projectId={project._id} images={project.images} />
      <ProjectMap location={location} />
    </div>
  )
}

function ProjectMap(props: { location: Location | null }) {
  if (!props.location) return null

  const { latitude, longitude } = props.location

  return (
    <div className="flex h-full flex-1">
      <iframe
        width="100%"
        height="100%"
        src={`https://www.google.com/maps/embed/v1/view?key=AIzaSyDrPqTzdRq1ifV4xAvm7RxqPQzXWrxelrc&center=${latitude},${longitude}&zoom=18`}
        loading="lazy"
        allowFullScreen></iframe>
    </div>
  )
}

function ProjectImages(props: {
  projectId: string
  images?: ProjectsItem['images']
}) {
  if (!props.images || props.images.length === 0) return null

  return (
    <div className="flex h-full flex-1">
      <ProjectImageCarousel
        projectId={props.projectId}
        usage="Popup"
        images={props.images}
      />
    </div>
  )
}
